class SearchPopout {
	constructor(el) {
		this.el = el;
		this.input = el.querySelector('input');
		this.originalPlaceholder = this.input.getAttribute('placeholder');
		this.attachHandlers();
	}

	attachHandlers() {
		this.setPlaceholderText();
		window.addEventListener('resize', () => {
			this.setPlaceholderText();
		});
	}

	setPlaceholderText() {
		if (window.innerWidth <= 768) {
			this.input.setAttribute('placeholder', 'Search');
		} else {
			this.input.setAttribute('placeholder', this.originalPlaceholder);
		}
	}
}

const els = document.querySelectorAll('.search-popout');
Array.from(els).forEach(el => new SearchPopout(el));